var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 15.445C13.4545 15.445 15.4444 13.4552 15.4444 11.0006C15.4444 8.546 13.4545 6.55615 10.9999 6.55615C8.54533 6.55615 6.55548 8.546 6.55548 11.0006C6.55548 13.4552 8.54533 15.445 10.9999 15.445Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8889 11H21M1 11H2.11111M11 19.8889V21M11 1V2.11111M17.2856 17.2856L18.0711 18.0711M3.92889 3.92889L4.71444 4.71444M4.71444 17.2856L3.92889 18.0711M18.0711 3.92889L17.2856 4.71444",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.61343d5722241f0c47fcadb6d509415e.svg";
export { ForwardRef as ReactComponent };